import MobilityHelper from "../../helpers/MobilityHelper"
import RouteHelper from "../../helpers/RouteHelper"
import { Article, ArticleCollection, PublicLocale } from "../../types"
import ERoute from "../ERoute"
import store from "../store"

export const overviewLink = (locale: PublicLocale) => {
  const { helpCenter: { currentLocale, customDomainEnabled, helpCenter } } = store.getState()

  return RouteHelper.process(ERoute.PATH_ROOT, {
    locale: currentLocale,
    // If custom domain is enabled, we don't need to pass helpCenterId
    ...(customDomainEnabled ? {} : { helpCenterId: helpCenter.slug })
  })
}

export const articleLink = (article: Article) => {
  const { helpCenter: { currentLocale, customDomainEnabled, helpCenter } } = store.getState()

  return RouteHelper.process(ERoute.PATH_ARTICLE, {
    locale: currentLocale,
    id: article.id,
    slug: MobilityHelper.getTranslation(currentLocale, article.translations, 'slug'),
    // If custom domain is enabled, we don't need to pass helpCenterId
    ...(customDomainEnabled ? {} : { helpCenterId: helpCenter.slug })
  })
}

export const collectionLink = (collection: ArticleCollection) => {
  const { helpCenter: { currentLocale, customDomainEnabled, helpCenter } } = store.getState()

  return RouteHelper.process(ERoute.PATH_COLLECTION, {
    locale: currentLocale,
    id: collection.id,
    slug: MobilityHelper.getTranslation(currentLocale, collection.translations, 'slug'),
    // If custom domain is enabled, we don't need to pass helpCenterId
    ...(customDomainEnabled ? {} : { helpCenterId: helpCenter.slug })
  })
}